import React from 'react'
import { Radio } from '@lightspeed/design-system-react'
import { MovementVariant } from '../utils/types'
import { useCashMovementsTypes } from '../utils/useCashMovementTypes'
import { CASH_MOVEMENTS, CASH_MOVEMENT_TYPES } from '../../../constants'

interface Props {
  variant: MovementVariant
  selectedType: CASH_MOVEMENT_TYPES
  onSelect: (type: CASH_MOVEMENT_TYPES) => void
}

export const TypeSelector: React.FC<Props> = ({
  variant,
  selectedType,
  onSelect,
}) => {
  const getTranslatedType = useCashMovementsTypes()

  return (
    <div className="vd-mt4 vd-mb4">
      {CASH_MOVEMENTS[variant].map(type => (
        <Radio
          key={type}
          label={getTranslatedType(type)}
          value={type}
          checked={selectedType === type}
          onChange={() => onSelect(type)}
          className="vd-mr4"
        />
      ))}
    </div>
  )
}
